import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getModel() {

                var form = {


                        id: "",
                        tabela: "",
                        id_pai: "",
                        nome: "",
                        email: "",
                        telefone: "",
                        ordem: "",
                        tipo_contato: "",
                        celular: "",
                        cargo: "",
                        setor: "",
                        funcao: ""

                }

                return form;
        },

        getById(id) {

                return Api.Call("contatos/" + id, "get", {});

        },

        salvar(form) {


                if (form.id != null && form.id != "") {

                        return Api.Call("contatos/" + form.id, "PUT", form);
                } else {


                        return Api.Call("contatos", "POST", form);


                }

        },
        getList(tabela, id_pai) {


                var data = { tabela: tabela, id_pai: id_pai }

                return Api.Call("contatos_gridcad?" + base.serialize(data), "get", data);


        },
        salvarGrid(hd_json, ids_delete_json, tabela, id_pai) {

                var data = {
                        hd_json: hd_json,
                        ids_delete_json: ids_delete_json,
                        tabela: tabela,
                        id_pai: id_pai
                };

                return Api.CallFormData("contatos_salvargrid", "POST", data);

        }


}
